import { getData, postData } from './api';

/**
 * Honey Pot API Service
 */
const HoneyPotAPI = {
  /**
   * Get the current active challenge and its questions.
   * Will return null if no challenge is active.
   */
  getActiveChallenge: async () => {
    try {
      return await getData('/honeypot/active');
    } catch (error) {
      console.error('Error fetching active honey pot challenge:', error);
      throw error;
    }
  },

  /**
   * Start a new attempt for a challenge.
   * @param {number} challengeId 
   */
  startAttempt: async (challengeId) => {
    try {
      return await postData('/honeypot/attempts/start', { challengeId });
    } catch (error) {
      console.error('Error starting honey pot attempt:', error);
      throw error;
    }
  },

  /**
   * Submit an attempt with answers to get scored.
   * @param {number} attemptId 
   * @param {Array} answers - [{ questionId, selectedOption }]
   * @param {number} timeTakenSeconds 
   */
  submitAttempt: async (attemptId, answers, timeTakenSeconds) => {
    try {
      return await postData(`/honeypot/attempts/${attemptId}/submit`, { answers, timeTakenSeconds });
    } catch (error) {
      console.error('Error submitting honey pot attempt:', error);
      throw error;
    }
  },

  /**
   * Disqualify an attempt (e.g. user minimized/closed unsubmitted)
   * @param {number} attemptId 
   */
  disqualifyAttempt: async (attemptId) => {
    try {
      return await postData(`/honeypot/attempts/${attemptId}/disqualify`);
    } catch (error) {
      console.error('Error disqualifying attempt:', error);
      throw error;
    }
  },

  /**
   * Get the user's past attempts history.
   */
  getMyAttempts: async () => {
    try {
      return await getData('/honeypot/attempts/my');
    } catch (error) {
      console.error('Error fetching honey pot attempts:', error);
      throw error;
    }
  }
};

export default HoneyPotAPI;
